import React, { Component } from 'react';
import Header from '../../../Header';
import MessageLink from '../../../MessageLink';
import Footer from '../../../Footer';
import PageDescription from '../../../PageDescription';
import BannerSingle from '../../../BannerSingle';
import Lgpd from '../../../Lgpd';
import TableSanfona from '../../../Tables/Sanfona';
import RentabilidadePeriodo from '../../../Tables/TabelaDinamica';
import ErrorBoundary from '../../../ErrorHandler/ErrorBoundary';

class RentabilidadeAPage extends Component {
	render() {
		return (
			<div>
				{/* HEADER */}{/* LOGIN */}
				<ErrorBoundary><Header /></ErrorBoundary>
				<main>
					<ErrorBoundary><BannerSingle image={"plano-a-rentabilidades"} page={"plano-a-rentabilidades"} /></ErrorBoundary>
					{/* Page description */}
					<ErrorBoundary><PageDescription page={'plano-a-rentabilidades'} /></ErrorBoundary>
					<div className="_the-content page-planos py-10">
						<div className='container'>
							<div className="row justify-content-center">
								<div className="col-md-10">
									<h3> RMA - Rentabilidade Mínima Atuarial </h3>
									<p>
										RMA - Rentabilidade Mímima Atuarial é a rentabilidade mínima que os ativos financeiros de um plano de benefícios deve ter para que possa cumprir com seus compromissos futuros. No caso do Plano A, a rentabilidade mínima atuarial esperada é de IPCA + 5,51% ao ano.
									</p>

									<br /> <br />

									<h4> Rentabilidade por período </h4>
									<ErrorBoundary><RentabilidadePeriodo page={'PARentabilidadePeriodo'} /></ErrorBoundary>

									<h4> Entenda a rentabilidade (ano / mês) </h4> <br/>
									
									<ErrorBoundary><TableSanfona page={"PARentabilidadeAnoMes"} /></ErrorBoundary>

								</div>
							</div>
						</div>
					</div>

					{/* Content page */}
				</main>
				{/* FOOTER */}
				<ErrorBoundary><Footer /></ErrorBoundary>
				{/* Message Link */}
				<ErrorBoundary><MessageLink /></ErrorBoundary>
				{/* LGPD */}
				<ErrorBoundary><Lgpd /></ErrorBoundary>
			</div>
		);
	}
};

export default RentabilidadeAPage;